import { Output, Injectable, EventEmitter } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Injectable()
export class ScreenService {
  @Output() changed = new EventEmitter();

  // This class follows the material design guidelines for breakpoints
  // https://m3.material.io/foundations/layout/applying-layout/window-size-classes
  constructor(private breakpointObserver: BreakpointObserver) {
    this.breakpointObserver
      .observe([ScreenSizeConstants.CompactBreakpoint, ScreenSizeConstants.MediumBreakpoint, ScreenSizeConstants.ExpandedBreakpoint, 
        ScreenSizeConstants.SXGABreakpoint, ScreenSizeConstants.HDPlusBreakpoint, ScreenSizeConstants.QHDBreakpoint])
      .subscribe((result) => {
        return this.changed.next(result);
      });
  }

  public isCompact() {
    const isCompact = this.sizes[ScreenSizeConstants.Compact];
    return isCompact;
  }

  public isMedium() {
    const isMedium = this.sizes[ScreenSizeConstants.Medium];
    return isMedium;
  }

  public isExpanded() {
    const isExpanded = this.sizes[ScreenSizeConstants.Expanded];
    return isExpanded;
  }

  public get sizes() {
    return {
      'screen-compact': this.breakpointObserver.isMatched(ScreenSizeConstants.CompactBreakpoint),
      'screen-medium': this.breakpointObserver.isMatched(ScreenSizeConstants.MediumBreakpoint),
      'screen-expanded': this.breakpointObserver.isMatched(ScreenSizeConstants.ExpandedBreakpoint)
    };
  }
}

export class ScreenSizeConstants {
  public static Compact = 'screen-compact';
  public static Medium = 'screen-medium';
  public static Expanded = 'screen-expanded';

  public static CompactBreakpoint = '(max-width: 600px)';
  public static MediumBreakpoint = '(min-width: 601px) and (max-width: 840px)';
  public static ExpandedBreakpoint = '(min-width: 840px)';
  public static SXGABreakpoint = '(min-width: 1280px)';
  public static HDPlusBreakpoint = '(min-width: 1600px)';
  public static QHDBreakpoint = '(min-width: 2560px)';
}